<template>
    <div class="status-container">
        <span :class="['status-icon', statusPagina]"></span>
        <span class="status-text">{{ statusText(statusPagina) }}</span>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const NOME_MODULO_VUEX = 'landingPage';

const statusPagina = computed(() => store.state[NOME_MODULO_VUEX].metadadosPagina.status);

const statusText = (status) => {
    switch (status) {
        case 'Rascunho':
            return 'Rascunho';
        case 'Publicado':
            return 'Publicado';
        case 'Desativado':
            return 'Desativado';
        default:
            return 'Status Desconhecido';
    }
};
</script>

<style scoped>
.status-container {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 16px;
    background-color: #f0f0f0;
    font-size: 14px;
    font-weight: 500;
}

.status-icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.status-text {
    color: #333;
}

.status-icon.Rascunho {
    background-color: #8a91a0;
}

.status-icon.Publicado {
    background-color: #28a745;
}

.status-icon.Desativado {
    background-color: #ff5757;
}
</style>
